import React from "react";
import { withRouter } from "react-router-dom";

import { Button } from "react-bootstrap";

import Select from "react-select";

import styles from "./style.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import CostsBlueprint from "components/Costs/CostsBlueprint";
import ChooseTimePeriodContainer from "containers/CreateWizard/Costs/ChooseTimePeriod";

export default class CurrentState extends React.PureComponent {
  render() {
    const {
      id,
      costs,
      processLimit,
      timePeriod,
      isHeader,
      isSmall,
      initRun,
      step,
      tile,
      updateStep,
      updateTimePeriod,
      blueprint,
      forceShow
    } = this.props;

    return (
      <div
        className={styles.currentState}
        style={isHeader ? { height: "150px", margin: "10px" } : isSmall ? { height: "230px" } : { height: "45vh" }}
      >
        {/*
        <div className={styles.tileHolder}>
          <div className={styles.tile}>{tile}</div>
        </div>
        */}
        <div
          className={styles.cHolder}
          style={
            step === "current"
              ? {
                  borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                  borderRadius: "3px"
                }
              : {}
          }
        >
          <div className={styles.editor}>
            <div className={styles.timePeriod}>
              <div className={styles.tMsg}>{"Time Period: "}</div>
              <div className={styles.timeOption}>
                <Select
                  value={{ value: timePeriod, label: timePeriod }}
                  options={[
                    { label: "Day", value: "Day" },
                    { label: "Week", value: "Week" },
                    { label: "Month", value: "Month" },
                    { label: "Quarter", value: "Quarter" },
                    { label: "Year", value: "Year" }
                  ]}
                  onChange={(val) => updateTimePeriod(val.value)}
                  menuPlacement="top"
                />
              </div>
            </div>
            {costs}
            <div className={styles.pLimit}>{processLimit}</div>
          </div>
        </div>
      </div>
    );
  }
}
